import ProjectCard from "./Cards/ProjectCard";
import ScrollReveal from "./Hooks/ScrollReveal";

const Projects = ({ projectData, col = 2, show = 4, otherProject = false , modalToggle}) => {
    return (
        <>
        
            {projectData.display &&
                <section className="pt-10 sm:mt-40 sm:flex sm:justify-center sm:flex-col  " id="work">
                    <div>
                        {!otherProject && <>
                            <ScrollReveal>
                                <h1 className="uppercase text-lg sm:text-2xl font-openSans font-semibold sm:text-center">Some Thing I've built</h1>
                            </ScrollReveal>
                            <ScrollReveal>
                                <h1 className="uppercase my-4 sm:mt-3 sm:mb-10 text-sm sm:text-lg font-openSans font-semibold underline underline-offset-1 sm:text-center">Featured Projects</h1>
                            </ScrollReveal>
                        </>
                        }

                        {otherProject &&
                            <div className="mt-0">
                                <ScrollReveal>
                                    <h1 className="uppercase my-4 sm:mt-3 sm:mb-10 text-sm sm:text-lg font-openSans font-semibold underline underline-offset-1 sm:text-center">Other Noteworthy Projects</h1>
                                </ScrollReveal>
                            </div>}

                    </div>
                    <div className={col == 2 ? "sm:m-auto sm:grid sm:grid-cols-2 sm:gap-x-32 sm:gap-y-8" : col == 3 ? "sm:m-auto sm:grid sm:grid-cols-3 sm:gap-8" : ""}>
                        {projectData.projects && projectData.projects.slice(0, show).map((Element, index) => (
                            <div >
                                <ProjectCard
                                    key={index}
                                    title={Element.title}
                                    tags={Element.tags}
                                    github={Element.github}
                                    website={Element.website}
                                    images={{ cover: Element.cover, hoverCover: Element.hoverCover }}
                                    hackathon={Element.hackathon}
                                    modalToggle = {()=>modalToggle(Element)}
                                    />
                            </div>
                        ))}
                    </div>
                </section>}
        </>
    );
};

export default Projects;